import React, {Fragment, useEffect, useState} from 'react';
import {Modal, Button, Table, Space, LoadingOverlay, Alert, ScrollArea} from '@mantine/core';
import {download, generateCsv, mkConfig} from "export-to-csv";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

export default function PreviewModal({size, isOpen, onClose, data}) {
    const { t } = useTranslation();
    let headers = false
    const [displayData, setDisplayData] = useState([])
    const [previewText, setPreviewText] = useState("")
    useEffect(() => {
        if (data.length > 50) {
            setDisplayData(data.slice(0, 50));
            setPreviewText("Preview shows a maximum of 50 endpoints.")
        } else {
            setDisplayData(data);
            setPreviewText("")
        }
    }, [data]);

    if(data.length !== 0){
        headers = Object.keys(data[0]);
    }
    let plural = "Endpoints"
    if(data.length === 1){
        plural = "Endpoint"
    }

    let string = `${t("Export Preview")} - (${data.length} ${t(plural)})`
    const csvConfig = mkConfig({useKeysAsHeaders: true, filename: "activations"});
    const downloadAndClose = () => {
        if(data.length === 0){
            let result = "EndpointSerialNumber,EncoderSerialNumber,EndpointStatus,NetworkStatus,MeterStatus,LastRegisterRead,CustomerName,ActivationTime,LastCommunicationTime" //This is the hardcoded output of an empty export, will need to be changed if export values change
            download(csvConfig)(result)
        }else{
            const formattedCSV = generateCsv(csvConfig)(data)
            download(csvConfig)(formattedCSV)
        }
        onClose()
    }
    const isExportLoading = useSelector(state => state.loading.isExportLoading);

    return (
        <div><LoadingOverlay visible={isExportLoading} zIndex={10}
                             overlayProps={{radius: "sm", blur: 1}}/>
        <Modal size={size} opened={isOpen} onClose={onClose} title={string}>
            {headers ? (<ScrollArea h={600} scrollbarSize={8}><Table>
                <Table.Thead>
                    <Table.Tr>
                        {headers.map((e)=>(
                            <Table.Th key={e}>{e}</Table.Th>
                        ))}
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                    {displayData.map((row, rowIndex) => (
                        <Table.Tr key={rowIndex}>
                            {headers.map((header) => (
                                <Table.Td key={header}>{row[header] === '' ? '-' : row[header]}</Table.Td>
                            ))}
                        </Table.Tr>
                    ))}
                </Table.Tbody>
            </Table>
                    {data.length > 50 ? (<Alert align="center">{t(previewText)}</Alert>) : (<Fragment/>)}
                </ScrollArea>
            ) : (
                <h1>{t("No Endpoints to Display")}</h1>
            )}
            <Space h="sm"></Space>
            <Button fullWidth={true} color="red" onClick={downloadAndClose}>{t("Export to CSV")}</Button>
        </Modal>
        </div>
    );
}